import { TimerIcon } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";

export type TimerProps = {
  isPayment: boolean;
};

export const Timer = ({ isPayment }: TimerProps) => {
  const { t } = useTranslation("translation", { keyPrefix: "GROUP_ACTIONS_ORDERING.TIMER" });

  return (
    <div className="flex items-center gap-3 rounded-xl border border-blue-200 bg-blue-50 p-4 text-blue-700 text-sm leading-relaxed">
      <TimerIcon size={24} className="shrink-0" />
      <p>{isPayment ? t("WITH_PAYMENT") : t("WITHOUT_PAYMENT")}</p>
    </div>
  );
};
